var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1604_110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 0C11.6533 0 0 11.6533 0 26C0 40.3467 11.6533 52 26 52C40.3467 52 52 40.3467 52 26C52 11.6533 40.3467 0 26 0ZM26 48C13.8667 48 4 38.1333 4 26C4 13.8667 13.8667 4 26 4C38.1333 4 48 13.8667 48 26C48 38.1333 38.1333 48 26 48Z",
    fill: "#01EDC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1198 16.7198L23.1998 31.0398L16.7465 24.5865C15.9732 23.8131 14.6932 23.8131 13.9198 24.5865C13.1465 25.3598 13.1465 26.6398 13.9198 27.4131L20.8798 34.3731C21.4932 34.9865 22.3465 35.3598 23.2265 35.3598H23.3598C24.2932 35.3065 25.1732 34.8798 25.7865 34.1598L38.1865 19.2798C38.9065 18.4265 38.7732 17.1731 37.9198 16.4531C37.0665 15.7598 35.8132 15.8665 35.0932 16.7198H35.1198Z",
    fill: "#01EDC7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1604_110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickRound);
export default __webpack_public_path__ + "static/media/tick-round.a19ec0c2cf0938ca78db9ded41dd17fa.svg";
export { ForwardRef as ReactComponent };